<div class="card kpi-blue">
    <div class="card-body kpi-card">
        <h5 class="card-title">Rendement moyen
            <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
               matTooltip="Rendement moyen de la ville
               ({{ (favorite.ad_city.renta['r_type'] == 'M' ?  'Pour les maisons uniquement ' : favorite.ad_city.renta['r_type'] == 'A' ? 'Pour les appartements uniquement ' : 'Tous types de  biens confondus ') }}  et sans prise en compte de travaux)"></i></h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- %</ng-container>
            <ng-container *ngIf="!preview && favorite.ad_city.renta">
                {{ favorite.ad_city.renta["r"] * 100| number: '1.0-1' }} %
            </ng-container>
        </p>
    </div>
</div>
